<onyx-message [intent]="type()" [clickable]="true" (redirect)="redirect.emit()">
  @let isError = type() === OnyxMessageType.ERROR;

  <onyx-icon
    id="document-expiration-issue"
    [name]="isError ? 'error-filled' : 'alert-circle-two-tone-filled'"
    [size]="20"
  ></onyx-icon>

  <div class="message">
    @if (label(); as label) {
      {{ `labels.${label}` | translate }}

      <span class="f-paragraph-s f-semibold">
        {{ `${I18N}.${isError ? 'expired' : 'expires'}` | translate }}
        @if (!count() && expiryDate(); as expiryDate) {
          {{ ' ' }}{{ expiryDate | onyxDate: 'date' }}
        }
      </span>
    } @else {
      <span class="f-paragraph-s f-semibold">
        {{
          `${I18N}.${isError ? 'documentsExpired' : 'documentsExpire'}`
            | translate: { count: count() }
        }}
        @if (!count() && expiryDate(); as expiryDate) {
          {{ ' ' }}{{ expiryDate | onyxDate: 'date' }}
        }
      </span>
    }
  </div>
</onyx-message>
